import { getApolloClient } from "../../apollo/client";
import gql from "graphql-tag";
import { getVehicleModelsQuery } from "../query/getVehicleModels.query";

const getVehicleModelsRequest = async (year, make) => {
  try {
    const res = await getApolloClient().mutate({
      mutation: gql`
        ${getVehicleModelsQuery(year,make)}
      `,
    });
    return res.data.getVehicleModels.edges;
  } catch (ex) {
    console.log(ex);
  }
};

export { getVehicleModelsRequest };
